import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../../mock/mock";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-36 bg-[#FFFDF6]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-14 md:mb-16 items-end">
          <div className="md:col-span-8 om-fade-up">
            <div className="uppercase tracking-[0.28em] text-[0.72rem] text-[#605F26] mb-6">
              You might be wondering
            </div>
            <h2 className="font-serif-display text-[#41232E] text-4xl md:text-6xl leading-[1.02] tracking-tight">
              About <em className="italic text-[#605F26]">The Owner&rsquo;s Mind.</em>
            </h2>
          </div>
        </div>

        <div className="border-t border-[#41232E]/15">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-[#41232E]/15">
                <button
                  className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className="font-serif-display text-[#41232E] text-xl md:text-3xl leading-snug">
                    {f.q}
                  </span>
                  <span className="shrink-0 mt-1 w-10 h-10 rounded-full border border-[#41232E]/30 flex items-center justify-center text-[#41232E] transition-colors">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100 pb-8" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-[#41232E]/75 text-lg leading-relaxed max-w-3xl">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
